import { useState, useEffect } from 'react';
import { Box, Typography, LinearProgress } from '@mui/material';
import { SimpleTreeView } from '@mui/x-tree-view/SimpleTreeView';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { useLocations } from '../../../../shared/context/locationsContext';
import { useNavigate } from 'react-router';
import { useUtiles } from '../../../../shared/context/utilesContext';
import { useAbility } from '../../../../shared/context/AbilityContext';

export default function TreeLocationsComponent() {
    const [expanded, setExpanded] = useState([]);
    const [selected, setSelected] = useState([]);
    const { locations, loadingLocations, getLocationsTree } = useLocations();

    const ability = useAbility();


    useEffect(() => {
        getLocationsTree();
    }, []);

    const handleToggle = (event, nodeIds) => {
        event.stopPropagation();
        setExpanded(nodeIds);
    };

    const handleSelect = (event, nodeIds) => {
        setSelected(nodeIds);
    };

    const navigate = useNavigate();

    const handleNavigate = (hash) => {
        if (ability.can('update', 'ASSETS.LOCATIONS')) {
            navigate(`/activos/ubicaciones/update/${hash}`);
        }
    }

    const renderTree = (nodes) => {
        return nodes.map((node) => (
            <TreeItem 
                key={node.id} 
                itemId={node.id.toString()} 
                label={
                    <Box sx={{ display: 'flex', flexDirection: 'column', py: 0.5 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <LocationOnIcon color="primary" sx={{ mr: 1 }} />
                            <Typography 
                                variant="body1" 
                                sx={{ fontWeight: 500, cursor: 'pointer' }}
                                onClick={(event) => {
                                    event.stopPropagation();
                                    handleNavigate(node.hash_code);
                                }}
                            >
                                {node.name}
                            </Typography>
                            {node.code && (
                                <Typography variant="caption" color="text.secondary" sx={{ ml: 1, fontWeight: 300 }}>
                                    {node.code}
                                </Typography>
                            )}
                        </Box>
                        <Typography variant="caption" color="text.secondary" sx={{ ml: 4, mt: 0.5 }}>
                            {node.location_path || " // "}
                        </Typography>
                    </Box>
                }
                
            >
                {Array.isArray(node.children) && node.children.length > 0
                    ? renderTree(node.children)
                    : null}
            </TreeItem>
        ));
    };

    if (loadingLocations) {
        return (
            <Box sx={{ width: '100%', mt: 2 }}>
                <LinearProgress />
            </Box>
        );
    }

    return (
        <Box sx={{ height: '100%', width: '100%', maxHeight: 'calc(100vh - 200px)', overflow: 'auto', padding: '10px' }}>
            {locations && locations.length > 0 ? (
                <SimpleTreeView
                    aria-label="locations tree"
                    expanded={expanded}
                    selected={selected}
                    onExpandedChange={handleToggle}
                    onSelect={handleSelect}
                    slots={{
                        expandIcon: AddIcon,
                        collapseIcon: RemoveIcon,
                    }}
                   
                    sx={{ flexGrow: 1, overflowY: 'auto' }}
                >
                    {renderTree(locations)}
                </SimpleTreeView>
            ) : (
                <Typography variant="body1" sx={{ p: 2 }}>
                    No hay ubicaciones disponibles.
                </Typography>
            )}
        </Box>
    );
}